export const GRID_SCHEDULE_INNER_HORIZONTAL_PADDING = 5;
export const GRID_SCHEDULE_LEFT_BORDER_WIDTH = 5;
export const GRID_SCHEDULE_BORDER_RADIUS = 5;
export const GRID_SCHEDULE_NOW_BUBBLE_SIZE = 15;
export const GRID_SCHEDULE_NOW_LINE_HEIGHT = 2;
